import React, { useState } from 'react';
import { Grid, IconButton, Button, Popover, Typography } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';
import { ReceiptOperation } from './ReceiptOperation';
import WSRadioField from '../../Components/Radio/WSRadio';
import { useForm } from 'react-hook-form';
import WSSCheckBoxField from '../../Components/CheckBox/WSCheckBox';
import config from '../../Config/clientConfig.json';

interface FooterProps {
  onViewChange: (view: string) => void;
  onToggleRecipeMode: (checked: boolean) => void;
}

const Footer: React.FC<FooterProps> = ({ onViewChange,onToggleRecipeMode  }) => {
  const { control, register } = useForm();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleViewChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onViewChange(event.target.value);
  };

  const open = Boolean(anchorEl);

  return (
    <Grid
      sx={{
        backgroundColor: '#333',
        padding: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Grid container spacing={2} alignItems="center" gap={3}>
        <Grid item>
      <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>
        <Grid item>
          <WSIcons.AppsIcon sx={{ color: "white" }} onClick={handleDialogOpen} />
        </Grid>
        <Grid item>
          <IconButton onClick={handlePopoverOpen}>
            <WSIcons.VisibilityIcon sx={{ color: "white" }} />
          </IconButton>
        </Grid>
        <Grid item>
          <WSIcons.SearchIcon sx={{ color: "white" }} />
        </Grid>
        <Grid item>
          <WSIcons.RoomServiceIcon sx={{ color: "white" }} />
        </Grid>
        <Grid item>
          <WSIcons.SoupKitchenIcon sx={{ color: "white" }} />
        </Grid>
        <Grid item>
          <WSIcons.Chair sx={{ color: "white" }} />
        </Grid>
        <Grid item>
          <WSIcons.Tag sx={{ color: "white" }} />
        </Grid>
        <Grid item>
          <WSIcons.RestaurantIcon sx={{ color: "white" }} />
        </Grid>
        <Grid item>
          <WSIcons.FireplaceIcon sx={{ color: "white" }} />
        </Grid>
      </Grid>

      {/* Right Side - Buttons */}
      <Grid sx={{ display: 'flex', alignItems: 'center' }} gap={2}>
        <Button
          variant="outlined"
          color="success"
          sx={{
            width: '9rem',
            borderColor: "green",
            color: "white",
          }}
        >
          Print & Finish
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: 'green',
            '&:hover': {
              backgroundColor: '#388e3c',
            },
          }}
        >
          Finish
        </Button>
      </Grid>


      <Popover
  open={open}
  anchorEl={anchorEl}
  onClose={handlePopoverClose}
  anchorOrigin={{
    vertical: 'top',
    horizontal: 'center',
  }}
  transformOrigin={{
    vertical: 'bottom',
    horizontal: 'center',
  }}
  PaperProps={{
    sx: {
      width: '200px',
      padding: '8px',
    },
  }}
>
  <Grid container spacing={1}>
    <Grid item xs={12}>
      <WSRadioField
        id="view"
        name="view"
        label=""
        control={control}
        defaultValue="current"
        options={config.viewConfig.staticOptionData}
        rules={{ required: true }}
        onChange={(event) => {
          handleViewChange(event); // Handle the change
          handlePopoverClose(); // Close the Popover after selection
        }}
      />
    </Grid>

    {/* Checkbox Field */}
    <Grid item xs={12}>
      <WSSCheckBoxField
        id="recipemode"
        {...register("recipemode")}
        label="Recipe Mode"
        control={control}
        rules={{ required: false }}
        defaultValue={false}
        onChange={(event) => {
          handlePopoverClose(); 
          onToggleRecipeMode(event.target.checked);
        }}
      />
    </Grid>
  </Grid>
</Popover>


      <ReceiptOperation open={dialogOpen} onClose={handleDialogClose} />
    </Grid>
  );
};

export default Footer;
